import {useEffect, useRef} from 'react'

export const useSubmitErrorNotification = ({resolvedSubmitError, onSubmitError}) => {
  const previousSubmitErrorRef = useRef(null)

  useEffect(() => {
    if (resolvedSubmitError && resolvedSubmitError !== previousSubmitErrorRef.current) {
      onSubmitError?.()
    }

    previousSubmitErrorRef.current = resolvedSubmitError
  }, [resolvedSubmitError, onSubmitError])
}

export default useSubmitErrorNotification
